/* eslint-disable max-len */
import React from "react";
import { connect } from "react-redux";
import { object, array, func, number, string } from "prop-types";
import get from "lodash/get";
import { LoadMoreCollectionStories } from "@quintype/components";

import More from "../../atoms/More";
import NewsWithImage from "../../molecules/NewsWithImage";
import ComponentContainer from "../../layouts/component-container";

import { staticTexts } from "../../utils/Translate";

import "./fourColStoriesWithLoadMore.m.css";

const NO_OF_STORIES_TO_LOAD = 8;

const FourColStoriesWithLoadMore = ({ collection, lang }) => {
  const { items = [], "associated-metadata": { number_of_stories_inside_collection_to_show: storiesToLoad } = {} } =
    collection;

  const stories = items
    .filter(({ type }) => type === "story")
    .map(({ story }) => story)
    .slice(0, storiesToLoad);

  if (!stories.length) {
    return null;
  }

  return (
    <ComponentContainer styleName="base" collection={collection}>
      <LoadMoreCollectionStories
        template={(e) => MoreCollectionStories(e, lang)}
        collectionSlug={collection.slug}
        data={{ stories: stories }}
        params={{ "item-type": "story" }}
        numStoriesToLoad={NO_OF_STORIES_TO_LOAD}
      />
    </ComponentContainer>
  );
};

function MoreCollectionStories({ stories, onLoadMore, noMoreStories }, lang) {
  return (
    <div>
      <div styleName="wrapper">
        {stories.map((story, index) => (
          <NewsWithImage key={index} story={story} />
        ))}
      </div>
      <div>
        {!noMoreStories ? (
          <div styleName={`load-more`}>
            <More type="load-more" text={staticTexts(lang).loadMore} onClick={onLoadMore} />
          </div>
        ) : null}
      </div>
    </div>
  );
}

FourColStoriesWithLoadMore.propTypes = {
  collection: object,
  story: object,
  lang: string,
};

MoreCollectionStories.propTypes = {
  stories: array.isRequired,
  onLoadMore: func,
  noMoreStories: number,
  lang: string,
};

FourColStoriesWithLoadMore.storyLimit = 4;

const mapStateToProps = (state) => ({
  lang: get(state, ["qt", "config", "publisher-attributes", "lang"], ""),
});

export default connect(mapStateToProps)(FourColStoriesWithLoadMore);
